import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { untilAll } from '../../utils/until-helpers';
import { perfNowOrTimestamp, UFOAbstractExperience } from './abstract-experience';
import { ExperiencePerformanceTypes, ExperienceTypes } from './experience-types';
import { PageSegmentExperienceTypes } from './page-segment-experience-types';
var UFOGlobalPageLoadExperience = /*#__PURE__*/function (_UFOAbstractExperienc) {
  _inherits(UFOGlobalPageLoadExperience, _UFOAbstractExperienc);
  var _super = _createSuper(UFOGlobalPageLoadExperience);
  function UFOGlobalPageLoadExperience() {
    var _this;
    _classCallCheck(this, UFOGlobalPageLoadExperience);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "loadingPageLoadId", 'UNKNOWN');
    _defineProperty(_assertThisInitialized(_this), "type", ExperienceTypes.Load);
    _defineProperty(_assertThisInitialized(_this), "performanceType", ExperiencePerformanceTypes.PageLoad);
    _defineProperty(_assertThisInitialized(_this), "initial", true);
    return _this;
  }
  _createClass(UFOGlobalPageLoadExperience, [{
    key: "startPageLoad",
    value: function startPageLoad(id) {
      var initial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var startTime = arguments.length > 2 ? arguments[2] : undefined;
      var result = _get(_getPrototypeOf(UFOGlobalPageLoadExperience.prototype), "start", this).call(this, initial ? 0 : perfNowOrTimestamp(startTime));
      this.setPageLoadId(id);
      this.initial = initial;
      return result;
    }
  }, {
    key: "updateConfig",
    value: function updateConfig(config) {
      Object.assign(this.config, config);
    }
  }, {
    key: "setPageLoadId",
    value: function setPageLoadId(id) {
      this.loadingPageLoadId = id;
    }
  }, {
    key: "getId",
    value: function () {
      var _getId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.loadingPageLoadId);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getId() {
        return _getId.apply(this, arguments);
      }
      return getId;
    }()
  }, {
    key: "exportData",
    value: function () {
      var _exportData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _get(_getPrototypeOf(UFOGlobalPageLoadExperience.prototype), "exportData", this).call(this);
            case 2:
              data = _context2.sent;
              return _context2.abrupt("return", _objectSpread(_objectSpread({}, data), {}, {
                initial: this.initial
              }));
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function exportData() {
        return _exportData.apply(this, arguments);
      }
      return exportData;
    }()
  }]);
  return UFOGlobalPageLoadExperience;
}(UFOAbstractExperience);
export var GlobalPageLoadExperience = new UFOGlobalPageLoadExperience('UFO_GLOBAL_PAGE_LOAD', {
  type: ExperienceTypes.Load,
  performanceType: ExperiencePerformanceTypes.PageLoad,
  // this should come from global config
  until: untilAll([{
    category: PageSegmentExperienceTypes.PRODUCT
  }])
});